module.exports = __webpack_public_path__ + "media/images/common/add_mycatalog_ov-dbd9bcb18c048571af91becdb2bb17e0.png";